import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Link from 'housecall-ui/dist/DesignSystem/Navigation/Link/Link';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';

import { useTrackEventsService } from 'components/Services/Analytics/useTrackEventsService';

import { PAY_WALL_VERSION } from './PayWallDialog';

const useStyles = makeStyles({
  contactUs: {
    fontWeight: 'bold',
  },
});

const ContactUsButton = (props: { label: string; intro?: string }): JSX.Element => {
  const { label, intro = '' } = props;
  const classes = useStyles();
  const { trackButtonClicked } = useTrackEventsService();
  const { Intercom } = window;

  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <Link
      color="primary"
      component="button"
      onClick={() => {
        trackButtonClicked({ buttonName: 'contact us on paywall', payWallVersion: PAY_WALL_VERSION });
        Intercom('showNewMessage', intro);
      }}
    >
      <Typography className={classes.contactUs}>{label}</Typography>
    </Link>
  );
};

export default ContactUsButton;
